export default __webpack_public_path__ + "static/media/welcome.74ee3a82.mp4";